import GenericInPlacePickList from '../pickList/GenericInPlacePickList'
import GenericPopupPickList from '../pickList/GenericPopupPickList'
import HierarchicalSearch from '../pickList/HierarchicalSearch'
import AddressSearch from '../pickList/AddressSearch'
import MapSearch from '../pickList/MapSearch'
import GenericMap from '../googleMap/genericMap'
import { findShapeCenter, WicketToGoogle } from '../pickList/WicketUtils'
import { drawAllShapes } from '../pickList/drawingManager'
import { ErrorMessage } from 'formik'
import { ArtificialDetailPropertyNames } from '../../../common/globalNotary'

export const renderBucket = (
  bucket,
  formikProps,
  editMode,
  styleClassName,
  superDisabled = false
) => {
  //genericSelect, hierarchicalSelect, addressSelect, mapSelect

  switch (bucket.componentType) {
    case 'addressSelect':
      return (
        <GenericPopupPickList
          selection={bucket.selection}
          // searchMoreCallback={oneBucket.searchCallback}
          // searchEntitySubType={oneBucket.searchEntitySubType}

          pickerEntityDisplayName={bucket.picklistEntityDisplayName}
          listPropertyName={bucket.listPropertyName}
          bucket={bucket}
          deepSetSelection={bucket.deepSetSelection}
          formikProps={formikProps}
          disabled={superDisabled || !editMode}
          children={
            <AddressSearch
              editMode={editMode}
              formikProps={formikProps}
              bucket={bucket}
            />
          }
        />
      )
    case 'mapSelect':
      const center = findShapeCenter(WicketToGoogle(bucket.fullSelection))

      const drawReadOnlyMap = mapHandle => {
        drawAllShapes(mapHandle, WicketToGoogle(bucket.fullSelection), false)
      }

      return (
        <>
          <GenericPopupPickList
            selection={bucket.selection}
            pickerEntityDisplayName={bucket.picklistEntityDisplayName}
            listPropertyName={bucket.listPropertyName}
            bucket={bucket}
            deepSetSelection={bucket.deepSetSelection}
            formikProps={formikProps}
            disabled={superDisabled || !editMode}
            children={
              <MapSearch
                editMode={editMode}
                formikProps={formikProps}
                bucket={bucket}
              />
            }
          />
          <GenericMap
            zoom={10}
            center={center}
            mapContainerStyle={{
              width: '25vw',
              height: '50vh'
            }}
            onLoad={drawReadOnlyMap}
            bucket= {bucket}
            mapName="main"
          />
        </>
      )
    case 'hierarchicalSelect':
      return (
        <GenericPopupPickList
          selection={bucket.selection}
          // searchMoreCallback={oneBucket.searchCallback}
          // searchEntitySubType={oneBucket.searchEntitySubType}
          pickerEntityDisplayName={bucket.picklistEntityDisplayName}
          listPropertyName={bucket.listPropertyName}
          bucket={bucket}
          deepSetSelection={bucket.deepSetSelection}
          formikProps={formikProps}
          disabled={superDisabled || !editMode}
          children={
            <HierarchicalSearch
              editMode={editMode}
              formikProps={formikProps}
              bucket={bucket}
            />
          }
        />
      )
    default:
      return (
        <>
          <GenericInPlacePickList
            selection={bucket.selection}
            searchMoreCallback={bucket.searchCallback}
            searchNoSystem={bucket.searchNoSystem}
            searchEntitySubType={bucket.searchEntitySubType}
            pickerEntityDisplayName={bucket.picklistEntityDisplayName}
            listPropertyName={bucket.listPropertyName}
            deepSetSelection={bucket.deepSetSelection}
            formikProps={formikProps}
            disabled={superDisabled || !editMode}
            listItemStyle={bucket.listItemStyle}
            listItemConfig={bucket.listItemConfig}
            collapsableContentClassName={styleClassName}
            equalityEvaluator={bucket.equalityEvaluator}
            superDisabled={superDisabled}
            isAddOnly={bucket.isAddOnly}
            isReadOnly={bucket.isReadOnly}
          />
          <div style={{ color: 'red' }}>
            <ErrorMessage
              name={ArtificialDetailPropertyNames.DETACHED_DEPENDENCY3}
            />
          </div>
        </>
      )
  }
}
